module.exports = __webpack_public_path__ + "img/shop.26f34f21.svg";